import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class sellerRelationsCtrl {
    /* @ngInject */
    constructor(
        logger,
        $translate,
        uiGridExporterConstants,
        $uibModal,
        PRINCIPAL,
        KISS_SELLER,
        KissSellerSvc,
        PrincipalSvc,
        SellerRelationFilter,
        $window
    ) {
        this.logger = logger;
        this.$translate = $translate;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.$uibModal = $uibModal;
        this.PRINCIPAL = PRINCIPAL;
        this.KISS_SELLER = KISS_SELLER;
        this.KissSellerSvc = KissSellerSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.SellerRelationFilter = SellerRelationFilter;
        this.$window = $window;
    }

    $onInit() {
        var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
        // ---------------
        // Data API
        // ---------------
        // Recherche
        this.seller = this.sellerBo.seller;
        this.dematModeList = this.PRINCIPAL.dematModes;
        this.ladTypesList = this.PRINCIPAL.searchableLadTypes;
        this.searchOpen = true;
        this.searchData = new this.SellerRelationFilter();
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'buyer.getCountryLabel()',
                    displayName: 'invited_entity_relation.list.country',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'buyer.getIdentifiant()',
                    displayName: 'invited_entity_relation.list.buyer_id',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'buyer.name',
                    displayName: 'invited_entity_relation.list.buyer_name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLadType()',
                    displayName: 'invited_entity_relation.list.lad_type',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getDematMode()',
                    displayName: 'invited_entity_relation.list.demat_mode',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'creationDate',
                    displayName: 'invited_entity_relation.list.creation_relation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'acceptation',
                    displayName: 'invited_entity_relation.list.acceptation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'endOfValidity',
                    displayName: 'invited_entity_relation.list.validity',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'detail',
                    displayName: 'Détail',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="ui-grid-cursor-pointer text-center" ng-click="grid.appScope.$ctrl.openRelation(row)">' +
                        '<i class="fa fa-info-circle link"></i></div>',
                    cellClass: 'pointer',
                    width: 80,
                },
            ],
            exporterOlderExcelCompatibility: true,
            onRegisterApi: gridApi => (this.gridApi = gridApi),
            enableSorting: true,
            enableGridMenu: false,
            data: this.relations,
            enableColumnMenus: false,
        };
    }
    searchPrincipals(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchPrincipals(value).then(principals => {
                return principals;
            });
        }
    }

    searchCompanies(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchCompanies(value).then(companies => {
                return companies;
            });
        }
    }

    search() {
        this.searchData.principal = this.PrincipalSvc.getPrincipal() ? this.PrincipalSvc.getPrincipal().detail : null;
        this.KissSellerSvc.searchRelations(this.seller.legalEntity.id, this.searchData).then(
            relations => {
                this.gridOptions.data = relations;
            },
            (/*error*/) => {
                this.logger.error('error.search');
            }
        );
    }

    clearForm() {
        // Reset data
        this.searchData = new this.SellerRelationFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    openRelation(row) {
        this.$uibModal
            .open({
                size: 'lg',
                component: 'editRelation',
                resolve: {
                    relation: () => {
                        return row.entity;
                    },
                    seller: () => {
                        return this.seller;
                    },
                },
            })
            .result.then(
                () => {},
                () => {}
            );
    }

    exportCsv() {
        this.gridOptions.exporterCsvFilename = 'relations-fournisseur_' + moment().format('DDMMYYYY') + '.csv';
        this.gridOptions.exporterHeaderFilter = this.$translate.instant;
        this.gridOptions.exporterSuppressColumns = ['detail'];
        this.gridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    back() {
        this.$window.history.back();
    }
}

angular.module('app.principal').component('sellerRelations', {
    templateUrl: require('./seller-relations.html'),
    controller: sellerRelationsCtrl,
    bindings: {
        sellerBo: '<',
        relations: '<',
        principalInfo: '<',
    },
});
